import { SET_MEGA_MENU_STATE } from 'redux/modules/page/actions/types';

export const setMegaMenuState = isMegaMenuOpen => ({
  type: SET_MEGA_MENU_STATE,
  isMegaMenuOpen,
});
